export default __webpack_public_path__ + "static/media/chat-with-astro.539e1a0c.png";